import { INSIGHTS_ACTION } from "../actions/insightsActions"
import { Action, InsightsData } from "../types"

export default (state = new InsightsData(), action: Action) => {
  switch (action.type) {
    case INSIGHTS_ACTION.FETCH_TRACK_PLAYLISTS:
      return { ...state, paginatedTrackPlaylists: action.payload }
    case INSIGHTS_ACTION.FETCH_SPOTIFY_CHART_ENTRIES:
      return { ...state, paginatedSpotifyChartEntries: action.payload }

    default:
      return state
  }
}
